// extracted by mini-css-extract-plugin
export default {"commonTasksItemsModal":"styles_common-tasks-items-modal__eCDns"};